import 'bootstrap/dist/css/bootstrap.min.css';

const DashboardHading = () =>{
  return   <h1 className="h3 mb-0 text-gray-800"
            style={{paddingBottom:'8px',fontWeight:'400'}}
            >Dashboard</h1>
}   


export default DashboardHading ;